// src/pages/LoginPage.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { apiUrl } from "../config/api";

function LoginPage() {
  const [formData, setFormData] = useState({
    identifier: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!formData.identifier.trim() || !formData.password.trim()) {
        throw new Error("نام کاربری و رمز عبور الزامی هستند");
      }

      const response = await fetch(apiUrl("/api/auth/login"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || data.error || "ورود ناموفق");
      }

      // ذخیره توکن و اطلاعات کاربر
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      toast.success("ورود با موفقیت انجام شد!");
      
      // ریدایرکت به صفحه اصلی
      navigate("/");

    } catch (error) {
      console.error("خطای ورود:", error);
      toast.error(error.message || "خطا در برقراری ارتباط با سرور");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <h2 className="register-title">🔐 ورود زرگر</h2>
        <p className="register-subtitle">
          با نام کاربری و رمز عبور خود وارد شوید
        </p>

        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-group">
            <label>نام کاربری (شماره تماس)</label>
            <input
              type="text"
              name="identifier"
              value={formData.identifier}
              onChange={handleChange}
              placeholder="شماره تماس خود را وارد کنید"
              required
            />
          </div>

          <div className="form-group">
            <label>رمز عبور</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="رمز عبور ۶ رقمی"
              maxLength={6}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="submit-btn"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                در حال ورود...
              </>
            ) : (
              "ورود"
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>
            حساب کاربری ندارید؟{" "}
            <Link to="/register" className="login-link">
              ثبت‌نام کنید
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
